<template>
    <div class="quiz">
        <div class="container">
            <div class="row">
                {{msg}}
                <div class="col-md-2">
                </div>
                <div class="col-md-8">
                    <h1>{{quiz.name}}</h1>
                    <span v-if="active_step===0" v-html="quiz_description"></span>
                    <div v-else style="margin-top:20px;">
                        <el-steps :active="active_step" finish-status="success">
                            <el-step v-for="step in steps" @click.native="goto(step)">
                                <template v-slot:title>
                                    <a :href="step.url" :style="step.style">{{ step.pretty_label }}</a>
                                </template>
                            </el-step>
                        </el-steps>
                    </div>
                    <h2>{{quiz_question.question_text}}</h2>
                    <span class="quiz"
                            style="font-family: freight-sans-pro, sans-serif;"
                          v-html="question_description">
                    </span>

                </div>

            </div>
        </div>

        <div class="container" style="margin-top:20px;">
            <div class="row" v-for="option in quiz_options" style="margin-top:20px;">
                <div class="col-md-2">
                </div>
                <div class="col-md-8" >
                    <el-button
                            type="primary"
                            plain
                            :style="option.style"
                            v-on:click="advance(option)"
                    >
                        {{option.label}}
                    </el-button>
                </div>
            </div>
            <div class="row" style="margin-top:30px">
                <div class="col-md-2">
                </div>
                <div class="col-md-8" >
                    <span v-if="existing_answer_text">{{existing_answer_text}}</span>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    import * as showdown from "showdown";
    showdown.setOption('tables', true);
    export default {
        name: "Quiz",
        props: ['quiz_id_from_blade','step_from_blade','quiz_session_uuid_from_blade', 'msg'],
        mounted() {
            // the values in the UUID quiz session will always be pulled first,
            // otherwise from what's been passed in the blade template
            let quiz_id = this.quiz_id_from_blade
            console.log('quiz_id from blade')
            console.log(quiz_id)

            const blade_uuid = this.quiz_session_uuid_from_blade
            console.log('uuid from blade')
            console.log(blade_uuid)

            let question_from_session = null

            const maybeCallApi = (blade_uuid) => {
                return new Promise((resolve, reject) => {
                    console.log('inside promise')
                    console.log(blade_uuid)
                    if (blade_uuid) {
                        console.log('about to get the quiz session')
                        axios.get("/quiz/u/get/" + blade_uuid)
                            .then(response => {
                                console.log(response.data)
                                this.quiz_session = response.data
                                quiz_id = this.quiz_session.quiz_id
                                question_from_session = this.quiz_session.current_question_id
                                console.log('in mounted, about to set resolved to true')
                                resolve(true)
                            })
                            .catch(error => {
                                console.log("Could not get quiz session " + this.quiz_session_uuid_from_blade)
                                reject(error)
                            })
                    } else {
                        resolve(null);
                    }
                })
            }

            maybeCallApi(blade_uuid).then((data) => {
                // data === null if did not call API
                console.log('continuing after maybeCallApi')
                if (quiz_id) {
                    console.log('about to get the quiz')
                    axios.get("/quiz/get/" + quiz_id)
                        .then(response => {
                            console.log(response.data)
                            this.quiz = response.data
                            let question_id = null
                            if (this.step_from_blade) {
                                // it's important that we do a == rather than === compare, since
                                // we may be comparing a string of a number and an actual number
                                this.existing_answer = this.quiz_session.answers.find(a => {
                                    return ((a.is_orphaned != true) && (a.order == this.step_from_blade))
                                })
                            }
                            if (this.existing_answer) {
                                question_id = this.existing_answer.question.id
                            } else if (question_from_session) {
                                question_id = question_from_session
                            } else {
                                question_id = this.quiz.first_question_id
                            }
                            if (question_id) {
                                this.quiz_question = this.quiz.questions.find(q => q.id === question_id)
                            }
                        })
                        .catch(error => {
                            console.log("Could not get quiz " + quiz_id)
                        })
                }
            })
        },
        data() {
            return {
                quiz: null,
                quiz_session: null,
                quiz_question: null,
            }
        },
        computed: {
            existing_answer_text: function() {
                if (this.existing_answer && !this.existing_answer.question.is_terminal) {
                    return "Your previous answer to this question: " + this.existing_answer.answer_text
                } else {
                    return null
                }
            },
            quiz_description: function () {
                let converter = new showdown.Converter()
                return converter.makeHtml(this.quiz.description)
            },
            question_description: function() {
                let converter = new showdown.Converter()
                return converter.makeHtml(this.quiz_question.question_description)
            },
            quiz_options: function() {
                let temp_options = []
                let existing_option_id = null
                if (this.existing_answer) {
                    existing_option_id = this.existing_answer.option_id
                }
                this.quiz_question.options.forEach(option => {
                    let temp_option = option
                    if (option.id == existing_option_id) {
                        temp_option.style = "float:left;font-size:24px;border-left: 3px solid black; border-spacing: 10px"
                    } else {
                        temp_option.style = "float:left;font-size:24px;"
                    }
                    temp_options.push(temp_option)
                })
                return temp_options
            },
            steps: function() {
                let temp_steps = []
                let count = 0
                let have_terminal = false // the terminal question could be this page or a subsequent page (after user has gone back)
                if (this.quiz_session) {
                    this.quiz_session.answers.forEach(answer => {
                        if (!answer.is_orphaned) {
                            if (answer.question.is_terminal) {
                                have_terminal = true
                            }
                            console.log('adding ' + answer.order + ' since it is not orphaned')
                            let temp_step = answer
                            if (answer.question.id !== this.quiz_question.id) {
                                temp_step.url = '/quiz/' + this.quiz.short + '/' + answer.short_label
                                temp_step.style = "color:#67C23A;font-weight: bold "
                            } else {
                                temp_step.style = "color:black;font-weight: bold;  text-decoration: overline; "
                            }
                            temp_steps.push(temp_step)
                        }
                    })
                    count = this.quiz_session.count
                }
                if (!this.existing_answer || this.existing_answer.is_orphaned) {
                    console.log('fox')
                    temp_steps.push({
                        short_label: this.quiz_question.short_label,
                        pretty_label: this.quiz_question.pretty_label,
                        order: count + 1
                    })
                }
                if (!have_terminal) {
                    console.log('hollow')
                    temp_steps.push({
                        short_label: 'next question(s)',
                        pretty_label: 'next question(s)',
                        order: count + 2
                    })
                }
                return temp_steps
            },
            // index starts at 0 -- this is what's highlighted in the Vue Element UI
            // steps
            active_step: function() {
                if (this.quiz_session) {
                    return this.quiz_session.answer_count
                } else {
                    return 0
                }
            }
        },
        methods: {
            goto(step) {
                window.location.href = step.url
            },
            advance(selected_option) {
                console.log('selected_option')
                console.log(selected_option)
                let blade_uuid = this.quiz_session_uuid_from_blade
                console.log('blade_uuid')
                console.log(blade_uuid)

                // first create a new quiz session, if needed
                const maybeCallApi = (blade_uuid) => {
                    return new Promise((resolve, reject) => {
                        console.log('blade_uuid')
                        console.log(blade_uuid)
                        if (!blade_uuid) {
                            axios.post('/quiz/u/', {
                                quiz_id: this.quiz.id,
                                current_question_id: this.quiz_question.id
                            }).
                                then((response) => resolve(response.data)).
                                catch(error => reject(error));
                        } else {
                            resolve(blade_uuid);
                        }
                    })
                }

                // regardless, do the actual advance
                maybeCallApi(blade_uuid).then((data) => {
                    // data === null means call did not happen
                    console.log('data coming to maybeCallApi')
                    console.log(data)
                    let uuid = data
                    axios.post('/quiz/advance/' + uuid, {
                        question_id: this.quiz_question.id,
                        answer: selected_option
                    }).
                    then((response) => {
                        console.log('returned from advance call')
                        console.log(response.data)
                        window.location.href = response.data
                    }).
                    catch((error) => {});
                })
            }
        },
    }
</script>

<style scoped>

</style>